module.exports = __webpack_public_path__ + "static/media/friendly-physio-1394X900.19a5a906.jpg";